<div class="d-flex flex-column">
  <app-member-verification-label-item
    label="First Name"
    i18n-label
    [text]="firstName$ | async"
    [isLoading]="isLoading$ | async"
    [highlightRow]="highlightFirstName" />
  <app-member-verification-label-item
    label="Last Name"
    i18n-label
    [text]="lastName$ | async"
    [isLoading]="isLoading$ | async"
    [highlightRow]="highlightLastName" />
  <app-member-verification-label-item
    label="SIN"
    i18n-label
    [text]="sinNumber$ | async"
    [isLoading]="isLoading$ | async"
    [highlightRow]="highlightSin" />
  <app-member-verification-label-item
    label="Date of Birth"
    i18n-label
    [text]="birthDate$ | async"
    [isLoading]="isLoading$ | async"
    [highlightRow]="highlightBirthDate"
    [hideBottomBorder]="true" />
</div>
